import { evidenceItems } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function EvidenceSection() {
  return (
    <section id="evidence" className="hll-scroll-anchor w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="EVIDENCE ROOM"
          title="实锤专区 · 逐条可核对的证据"
          desc="黑料吃瓜网实锤与黑料吃瓜网证据集中放在这里：材料、凭证、原件各自成册，标号归档，支持按类别逐项核对。"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {evidenceItems.map((item) => (
            <article
              key={item.id}
              className="group overflow-hidden rounded-lg border border-background-300/60 bg-background-100"
            >
              <div className="relative h-[200px] w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 黑料吃瓜网实锤证据`}
                  title={`${item.title} 黑料吃瓜网证据归档`}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs text-foreground-800">
                  {item.label}
                </span>
                {item.verified ? (
                  <span className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-shield-check-line text-sm"></i>
                    </span>
                    已核验
                  </span>
                ) : (
                  <span className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full bg-secondary-500 px-3 py-1 text-xs text-background-50">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-loader-4-line text-sm"></i>
                    </span>
                    整理中
                  </span>
                )}
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <a
                  href="#resource"
                  className="mt-4 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm text-secondary-700 transition-colors hover:text-secondary-900"
                >
                  查看材料清单
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}